"use client";

import { useEffect, useState } from 'react';
import { authMe } from './authApi';
import { resolveLocalUatAuthContext } from './local-uat-auth';

export const useCompanyId = () => {
  const [tenantId, setTenantId] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [roles, setRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isCancelled = false;
    setLoading(true);
    setError(null);

    const localUatAuthContext =
      typeof window === 'undefined' ? null : resolveLocalUatAuthContext(window.localStorage);
    if (localUatAuthContext) {
      setTenantId(localUatAuthContext.tenantId);
      setUserId(localUatAuthContext.userId);
      setRoles(localUatAuthContext.roles);
      setLoading(false);
      return () => {
        isCancelled = true;
      };
    }

    authMe()
      .then((me) => {
        if (isCancelled) return;
        setTenantId(me?.companyId ?? null);
        setUserId(me?.userId ?? null);
        setRoles(me?.roles ?? []);
      })
      .catch((err: any) => {
        if (isCancelled) return;
        setTenantId(null);
        setUserId(null);
        setRoles([]);
        setError(err?.message ?? 'Failed to load auth context');
      })
      .finally(() => {
        if (isCancelled) return;
        setLoading(false);
      });

    return () => {
      isCancelled = true;
    };
  }, []);

  return { tenantId, userId, roles, loading, error };
};
